export default "__VITE_ASSET__xQ2SS9S$__"